import React from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  TextField,
  Button,
  Box,
} from '@mui/material';

const GroupAdjustment = ({
  aaManagedId,
  groupBreaks,
  currentValues,
  enforceBounds,
  onChange,
  onRevert,
  onSave,
  onClose,
}) => {
  const getAdjusted = (val, defaultValue) => {
    if (Number.isNaN(val)) return defaultValue;
    return val;
  };

  const handleChange = (groups, group) => (e) => {
    const itemIndex = groups.findIndex((g) => g.minValue === group.minValue);
    if (itemIndex >= 0) {
      onChange([
        ...groups.slice(0, itemIndex),
        {
          aaManagedId,
          minValue: group.minValue,
          maxValue: group.maxValue,
          adjustmentFactor: e.target.value,
        },
        ...groups.slice(itemIndex + 1),
      ]);
    }
  };

  const currentValueMap = currentValues
    ? currentValues.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.minValue]: cur.adjustmentFactor,
        }),
        {},
      )
    : {};

  const groups = (
    currentValueMap && Object.keys(currentValueMap).length > 0
      ? Object.keys(currentValueMap)
      : groupBreaks
  ).map((key) => ({
    aaManagedId,
    minValue: key,
    maxValue: key,
    adjustmentFactor: currentValueMap[key],
  }));

  const itemsPerColumn = Math.ceil(groups.length / 3);
  const column1 = groups.slice(0, itemsPerColumn);
  const column2 = groups.slice(itemsPerColumn, itemsPerColumn * 2);
  const column3 = groups.slice(itemsPerColumn * 2);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '.5em' }}>
      {column1.length > 0 ? (
        <Paper sx={{ width: '214px', marginRight: '.5em' }}>
          <List>
            {column1.map((group) => (
              <ListItem key={group.minValue}>
                <ListItemText
                  id={`group-${group.minValue}`}
                  primary={`Input ${group.minValue}`}
                />
                <ListItemSecondaryAction
                  style={{
                    width: '54px',
                    right: '100px',
                    paddingBottom: '5px',
                  }}
                >
                  <TextField
                    variant="standard"
                    id={`group-adjustment-${group.minValue}`}
                    key={group.minValue}
                    value={group.adjustmentFactor}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                    onChange={handleChange(groups, group)}
                  />
                </ListItemSecondaryAction>
                <ListItemText
                  style={{
                    marginLeft: '55px',
                  }}
                  primary={`Adjusted ${getAdjusted(
                    parseInt(group.minValue, 10) +
                      enforceBounds(
                        parseInt(group.adjustmentFactor, 10),
                        parseInt(group.minValue, 10),
                      ),
                    group.minValue,
                  )}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      ) : null}

      {column2.length > 0 ? (
        <Paper sx={{ width: '214px', marginRight: '.5em' }}>
          <List>
            {column2.map((group) => (
              <ListItem key={group.minValue}>
                <ListItemText
                  id={`group-${group.minValue}`}
                  primary={`Input ${group.minValue}`}
                />
                <ListItemSecondaryAction
                  style={{
                    width: '54px',
                    right: '100px',
                    paddingBottom: '5px',
                  }}
                >
                  <TextField
                    variant="standard"
                    id={`group-adjustment-${group.minValue}`}
                    key={group.minValue}
                    value={group.adjustmentFactor}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                    onChange={handleChange(groups, group)}
                  />
                </ListItemSecondaryAction>
                <ListItemText
                  style={{
                    marginLeft: '55px',
                  }}
                  primary={`Adjusted ${getAdjusted(
                    parseInt(group.minValue, 10) +
                      enforceBounds(
                        parseInt(group.adjustmentFactor, 10),
                        parseInt(group.minValue, 10),
                      ),
                    group.minValue,
                  )}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      ) : null}

      {column3.length > 0 ? (
        <Paper sx={{ width: '214px' }}>
          <List>
            {column3.map((group) => (
              <ListItem key={group.minValue}>
                <ListItemText
                  id={`group-${group.minValue}`}
                  primary={`Input ${group.minValue}`}
                />
                <ListItemSecondaryAction
                  style={{
                    width: '54px',
                    right: '100px',
                    paddingBottom: '5px',
                  }}
                >
                  <TextField
                    variant="standard"
                    id={`group-adjustment-${group.minValue}`}
                    key={group.minValue}
                    value={group.adjustmentFactor}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                    onChange={handleChange(groups, group)}
                  />
                </ListItemSecondaryAction>
                <ListItemText
                  style={{
                    marginLeft: '55px',
                  }}
                  primary={`Adjusted ${getAdjusted(
                    parseInt(group.minValue, 10) +
                      enforceBounds(
                        parseInt(group.adjustmentFactor, 10),
                        parseInt(group.minValue, 10),
                      ),
                    group.minValue,
                  )}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      ) : null}

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          width: '130px',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
        }}
      >
        <List>
          <ListItem>
            <Button onClick={onRevert} variant="contained" color="inherit">
              Revert
            </Button>
          </ListItem>
          <ListItem>
            <Button onClick={onSave} variant="contained" color="inherit">
              Save
            </Button>
          </ListItem>
          <ListItem>
            <Button onClick={onClose} variant="contained" color="inherit">
              Close
            </Button>
          </ListItem>
        </List>
      </Box>
    </div>
  );
};

export default GroupAdjustment;
